import { logoutWtApp } from "../androidAndIosApp";
import { isAppTypeIframe } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { getRedirectProps, redirect } from "./redirect";
import { useKeycloakAuth } from "../business-components/adminSettings/AdminContext";

export const useLogOut = () => {
  const settings = useSettings();
  const useKeycloak = useKeycloakAuth();

  return () => {
    if (window.iswtapp) {
      logoutWtApp();
    }

    let params = new URLSearchParams();

    if (window.cvpIdConcern) {
      params.append("k", window.cvpIdConcern.toString());
    }

    let urlToGoToAfterLogout = isAppTypeIframe()
      ? settings.iframe_startPage
      : "/";

    const redirectUri = getRedirectProps(urlToGoToAfterLogout, {
      mergeQs: {
        k: window.cvpIdConcern ?? null,
      },
    }).href;

    const searchParams = new URLSearchParams();
    searchParams.set("redirectUri", redirectUri);
    const qs = searchParams.toString();

    // Use Keycloak only when toggle is enabled (for local IP users)
    // Otherwise use VismaConnect
    const authProvider = useKeycloak ? "keycloak/" : "";

    redirect(`${location.origin}/auth/${authProvider}logout?${qs}`, {
      mergeQs: {},
      redirectRaw: true,
    });
  };
};
